<template xmlns:v-bind="http://www.w3.org/1999/xhtml"
          xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div class="typewriter-font"
       :class="{ 'print-preview': showPrintPreview }">
    <div class="print-toggle" v-if="!isFromFinestHour">
      Print preview
      <toggle-button v-model="showPrintPreview"/>
    </div>
    <div class="editor">
      <h1>
        <span class="decorative-font">Bag the Hun</span>
        <span class="dash">–</span>
        <small>Squadron editor</small></h1>
      <hr>
      <form class="form">
        <div class="row">
          <div class="label">Nation:</div>
          <div class="control">
            <select name="nation"
                    id="nation" v-model="squadron.country">
              <option v-for="country in Countries"
                      v-bind:key="country.name"
                      :value="country">{{ country.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="label">Squadron color:</div>
          <div class="control">
            <select name="color"
                    id="color" v-model="squadron.color">
              <option v-for="color in Colors"
                      v-bind:key="color.rgb"
                      :value="color.rgb">{{ color.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="label">Squadron name:</div>
          <div class="control">
            <input type="text" v-model="squadron.name">
          </div>
        </div>
        <div class="row">
          <div class="label">Pilots:</div>
          <div class="control">
            <table>
              <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Rank</th>
                <th>Aircraft</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="pilot in squadron.pilots" v-bind:key="pilot.id">
                <td>{{ pilot.id }}</td>
                <td><input type="text" v-model="pilot.name"></td>
                <td><select name="rank" v-model="pilot.rank">
                  <option v-for="rank in PilotRanks"
                          v-bind:key="rank"
                          :value="rank">{{ rank }}
                  </option>
                </select></td>
                <td><select name="aircraft" v-model="pilot.aircraft">
                  <option v-for="aircraft in Aircrafts"
                          v-bind:key="aircraft.type"
                          :value="aircraft">{{ aircraft.type }}
                  </option>
                </select></td>
                <td><a href="#"
                       @click="squadron.removePilot(pilot)">delete</a></td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <td colspan="5"><a href="#" @click="squadron.addPilot()">+ add pilot</a></td>
              </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </form>
      <hr>
    </div>
    <div class="squadron">
      <div class="country">
        <div class="logo"><img :src="squadron.country.logo" alt=""></div>
        <div class="name">{{ squadron.country.name }}</div>
        <div class="squadron-name">–&nbsp;
          <span class="color-badge"
                :style="`background-color: ${ squadron.color };`"></span>{{
                                   squadron.name }}
        </div>
      </div>
      <div class="pilots">
        <div class="pilot" v-for="pilot in squadron.pilots" v-bind:key="pilot.name">
          <div class="pilot-frame">
            <div class="pilot-header decorative-font">
              <div class="pilot-id typewriter-font-bold">#{{ pilot.id }}</div>
              <div>–</div>
              <div class="pilot-name">{{ pilot.name }}</div>
              <div class="pilot-rank typewriter-font-bold">
                {{ pilot.rank }}
              </div>
            </div>
            <div class="aircraft">
              <div class="aircraft-type attribute">
                <span class="label">Aircraft:</span>
                <div class="dots"></div>
                <span class="value">{{ pilot.aircraft.type }}</span>
              </div>
              <div class="aircraft-stats">
                <table>
                  <tbody>
                  <tr>
                    <td>
                      <div class="stat-cell"><span>SPD</span><span>{{ pilot.aircraft.spd }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="stat-cell"><span>MAN</span><span>{{ pilot.aircraft.man }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="stat-cell"><span>ALT</span><span>{{ pilot.aircraft.alt }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="stat-cell"><span>ROC</span><span>{{ pilot.aircraft.roc }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="stat-cell"><span>ROB</span><span>{{ pilot.aircraft.rob }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="stat-cell"><span>SIZ</span><span>{{ pilot.aircraft.siz }}</span>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="aircraft-weapons attribute">
                <span class="label">Weapons:</span>
                <div class="dots"></div>
                <span class="value">{{ pilot.aircraft.gun }}</span>
              </div>
              <div class="aircraft-firefactor">
                <table>
                  <tbody>
                  <tr>
                    <td>
                      <div class="stat-cell">
                        <span>AMMO</span><span>{{ pilot.aircraft.ammoLimit }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="stat-cell">
                        <span>FRONT</span><span>{{ pilot.aircraft.front }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="stat-cell">
                        <span>RIGHT</span><span>{{ pilot.aircraft.right }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="stat-cell"><span>LEFT</span><span>{{ pilot.aircraft.left }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="stat-cell"><span>REAR</span><span>{{ pilot.aircraft.rear }}</span>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!--            <div class="aircraft-ammo attribute">-->
              <!--              <span class="label">Ammo Limit:</span>-->
              <!--              <div class="dots"></div>-->
              <!--              <span class="value">{{ pilot.aircraft.ammoLimit }}</span>-->
              <!--            </div>-->
              <div class="aircraft-ammo-left" v-if="pilot.ammoSlots != null">
                <div class="attribute">
                  <div class="label">Ammo used:</div>
                </div>
                <table>
                  <colgroup>
                    <col v-for="i in Array.from(Array(10).keys())" v-bind:key="i" width="10">
                  </colgroup>
                  <tbody>
                  <tr v-for="r in pilot.ammoSlotRows" v-bind:key="r.i">
                    <td v-for="i in r.ammoSlots" v-bind:key="i"></td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div v-else="" class="spacer"></div>
              <div class="attribute">
                <span class="label"
                      v-if="pilot.aircraft.other != null && pilot.aircraft.other.trim() !== ''">
                  Notes:</span>
              </div>
              <div class="aircraft-other">{{ pilot.aircraft.other }}</div>
              <div class="damage-record attribute">
                <span class="label">Damage:</span>
                <div class="dots"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import Squadron from '@/models/Squadron';
  import Pilot from '@/models/Pilot';
  import Aircrafts from '@/models/Aircrafts';
  import Countries from '@/models/Countries';
  import PilotQuality from '@/models/PilotQuality';

  export default {
    props: {
      initialSquadron: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        isFromFinestHour: false,
        showPrintPreview: false,
        Aircrafts,
        Colors: [
          {
            name: 'Red',
            rgb: '#ff0000',
          },
          {
            name: 'Blue',
            rgb: '#082985',
          },
          {
            name: 'Yellow',
            rgb: '#cbbf00',
          },
          {
            name: 'Green',
            rgb: '#457e52',
          },
        ],
        Countries,
        PilotRanks: PilotQuality,
        squadron: new Squadron({
          name: 'Section #1',
          country: Countries.find((x) => x.name === 'Great Britain'),
          pilots: [
            new Pilot({
              id: 1,
              name: 'Turner Lighton',
              rank: PilotQuality[0],
              aircraft: Aircrafts.find((x) => x.type.includes('Spitfire')),
            }),
            new Pilot({
              id: 2,
              name: 'Willie Stroker',
              rank: PilotQuality[2],
              aircraft: Aircrafts.find((x) => x.type.includes('Spitfire')),
            }),
            new Pilot({
              id: 3,
              name: 'Dan Druff',
              rank: PilotQuality[4],
              aircraft: Aircrafts.find((x) => x.type.includes('Spitfire')),
            }),
            new Pilot({
              id: 4,
              name: 'Barry Cade',
              rank: PilotQuality[1],
              aircraft: Aircrafts.find((x) => x.type.includes('Spitfire')),
            }),
            new Pilot({
              id: 5,
              name: 'Tim Burr',
              rank: PilotQuality[2],
              aircraft: Aircrafts.find((x) => x.type.includes('Spitfire')),
            }),
            new Pilot({
              id: 6,
              name: 'Dick Burns',
              rank: PilotQuality[4],
              aircraft: Aircrafts.find((x) => x.type.includes('Spitfire')),
            }),
          ],
        }),
        // squadron: new Squadron({
        //   name: 'Section #1',
        //   country: Countries.find((x) => x.name === 'Germany'),
        //   pilots: [
        //     new Pilot({
        //       id: 1,
        //       name: 'Otto Graph',
        //       rank: PilotQuality[0],
        //       aircraft: Aircrafts.find((x) => x.type.includes('109F')),
        //     }),
        //     new Pilot({
        //       id: 2,
        //       name: 'Ingo Sipper',
        //       rank: PilotQuality[2],
        //       aircraft: Aircrafts.find((x) => x.type.includes('109F')),
        //     }),
        //     new Pilot({
        //       id: 3,
        //       name: 'Heinrich Flauer',
        //       rank: PilotQuality[4],
        //       aircraft: Aircrafts.find((x) => x.type.includes('109F')),
        //     }),
        //     new Pilot({
        //       id: 4,
        //       name: 'Martin Foil',
        //       rank: PilotQuality[1],
        //       aircraft: Aircrafts.find((x) => x.type.includes('109F')),
        //     }),
        //     new Pilot({
        //       id: 5,
        //       name: 'Rudi Spatsher',
        //       rank: PilotQuality[2],
        //       aircraft: Aircrafts.find((x) => x.type.includes('109F')),
        //     }),
        //     new Pilot({
        //       id: 6,
        //       name: 'Walter Oritch',
        //       rank: PilotQuality[4],
        //       aircraft: Aircrafts.find((x) => x.type.includes('109F')),
        //     }),
        //   ],
        // }),
      };
    },
    methods: {
      backToFinestHour() {
        this.$emit('done');
      },
    },
    beforeMount() {
      if (this.initialSquadron != null) {
        this.squadron = new Squadron({
          ...this.initialSquadron,
        });
        this.showPrintPreview = true;
        this.isFromFinestHour = true;
      }
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../vars";

  .print-toggle {
    position: absolute;
    right: 1.6rem;
    top: 2.8rem;
  }

  h1 {
    padding: 0.3rem 1.6rem;

    .decorative-font {
      letter-spacing: -0.1rem;
    }

    .dash {
      margin: 0 1.6rem;
      font-weight: 400;
    }

    small {
      color: #00000099;
    }
  }

  .form {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-size: 1.5rem;
    padding: 1.6rem;

    input, select {
      font-family: Avenir, Helvetica, Arial, sans-serif;
      font-size: 1.5rem;
    }

    input {
      border: solid 0.1rem $border-color;
      border-radius: 0.4rem;
      padding: 0.4rem 1rem;
    }

    .row {
      display: flex;
      align-items: flex-start;
      margin-bottom: 1rem;

      .label {
        flex-basis: 30%;
        font-weight: 500;
      }

      .control {

      }
    }

    table {
      border-spacing: 0;

      thead {
        tr {
          th {
            padding: 0.6rem 0.6rem;
          }
        }
      }

      tbody {
        tr {
          background-color: #00000000;

          &:nth-of-type(odd) {
            background-color: #00000007;
          }

          td {
            padding: 0.6rem 0.6rem;
            border-top: solid 0.1rem transparentize($border-color, 0.5);

            &:first-of-type {
              padding-left: 1.2rem;
            }

            &:last-of-type {
              padding-right: 1.2rem;
            }
          }
        }
      }

      tfoot {
        td {
          padding: 0.6rem 0.6rem;
          border-top: solid 0.1rem $border-color;
        }
      }
    }
  }

  .attribute {
    display: flex;
    align-items: center;
    margin-bottom: 0.6rem;

    .label {
    }

    .dots {
      padding-top: 0.8rem;
      flex-grow: 1;
      border-bottom: dotted 0.1rem #00000033;
      margin-left: 0.6rem;
      margin-right: 0.6rem;
    }

    .value {
      font-weight: 700;
    }
  }

  .squadron {
    .squadron-name {
      font-size: 1.5em;
      /*font-size: 1.2em;*/
      font-weight: 700;
      margin-left: 1rem;
      display: flex;
      align-items: center;
    }

    .color-badge {
      display: inline-block;
      border-radius: 1rem;
      width: 2rem;
      height: 2rem;
      margin: 0 0.6rem 0 1rem;
    }
  }

  .country {
    margin-left: 1.6rem;
    display: flex;
    align-items: center;
    margin-top: 1.6rem;
    margin-bottom: 1.6rem;

    .logo {
      margin-right: 1rem;

      img {
        max-height: 3.2rem;
      }
    }

    .name {
      font-size: 1.5em;
    }
  }

  .pilots {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    //align-items: flex-start;
  }

  .pilot {
    display: flex;
    flex-direction: column;
    border: solid 1rem #fff;
    box-shadow: 0 0 2rem #00000033;
    background-color: $paper-color;
    background-image: url('http://api.thumbr.it/whitenoise-400x40.png?background=fff3e3ff&noise=626262&density=22&opacity=16');
    color: $text-color;
    margin-bottom: 3.2rem;
    margin-left: 1.6rem;
    margin-right: 1.6rem;
    flex-basis: 0;

    .pilot-frame {
      border: solid 0.1rem transparentize($text-color, 0.6);
      padding: 1.6rem;
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .pilot-header {
      display: flex;
      align-items: center;
      /*font-weight: 700;*/
      font-size: 1.4em;
      border-bottom: solid 0.1rem #00000033;
      padding-bottom: 0.3rem;
      margin-bottom: 1rem;

      .pilot-id {
        margin-right: 0.6rem;
        letter-spacing: 0.2rem;
      }

      .pilot-name {
        flex-grow: 1;
        margin-left: 0.6rem;
      }

      .pilot-rank {
        font-size: 0.9em;
      }
    }

    table {
      min-width: 100%;
      border: solid 0.1rem transparentize($text-color, 0.2);
      padding: 0;
      border-spacing: 0;
      margin-bottom: 1rem;
      background: transparentize($text-color, 0.65);

      td {
        border-left: solid 0.1rem transparentize($text-color, 0.5);
        border-bottom: solid 0.1rem transparentize($text-color, 0.5);

        &:first-of-type {
          border-left-width: 0;
        }

        padding: 0;

        .stat-cell {
          padding: 1rem;
          display: flex;
          flex-direction: column;
          align-items: center;

          span:first-of-type {
            font-weight: 700;
            margin-bottom: 0.6rem;
          }

          span:last-of-type {
            font-weight: 700;
            font-size: 1.2em;
          }
        }
      }

      tr:last-of-type {
        td {
          border-bottom-width: 0;
        }
      }
    }

    .aircraft {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
    }

    .aircraft-ammo-left {
      table {
        background-image: repeating-linear-gradient(-45deg,
          transparent 0 2px,
          transparentize($text-color, 0.67) 2px 4px);

        td {
          height: 2rem;
          background-color: $paper-color;
        }
      }
    }

    .aircraft-other {
      margin-bottom: 1.6rem;
    }
  }

  .spacer {
    flex-grow: 1;
  }

  .print-preview {
    page-break-after: always;
    .editor {
      display: none;
    }
  }

  @media print {
    .editor, .print-toggle {
      display: none;
    }
    header nav, footer {
      display: none;
    }

    @page {
      margin: 0.5cm;
    }

    .squadron {
      -webkit-print-color-adjust: exact;
      font-size: 25%;
    }

    .country {
      margin-top: 0;
      margin-left: 1rem;
      margin-bottom: 0;
      font-size: 1.4rem;
    }

    .pilot {
      margin-left: 0;
      margin-right: 0;
      margin-bottom: 0;
      margin-top: 1rem;
      box-shadow: none;
      border: none;
      flex-basis: 32%;

      .pilot-header {
        font-size: 1.6rem;
      }

      table {
        td {
          .stat-cell {
            span:first-of-type {
              margin-bottom: 0.2rem;
            }
          }
        }
      }
    }
  }
</style>
